<div>
  <label class="role-switchers__label">{{ 'core.role' | translate }}</label>

  <mat-spinner *ngIf="loading" diameter="24" class="role-switchers__spinner"></mat-spinner>

  <div class="role-switchers__list" *ngIf="!loading">
    <div class="role-switchers__row" [class.role-switchers__row--unavailable]="!role.available"
      *ngFor="let role of options">
      <mat-slide-toggle [checked]="isEnabled(role)" (change)="toggleRole(role, $event)" [disabled]="!role.available"
        [attr.data-cy]="'toggle-role-' + role.name">
        {{ role.name | translate }}
      </mat-slide-toggle>
    </div>
  </div>

  <mat-error *ngIf="enabled.length === 0">
    {{ 'info.specify_some_roles' | translate }}
  </mat-error>
</div>
